import axios from "../utils/axios";

// 🏢 Get shipment
export const getActiveBank = async () => {
  const response = await axios.get("/api/Bank/GetAll");
  //console.log(response);
  return response.data;
};

// 🏢 Get single address
export const getSingleBank = async (bankId) => {
  const response = await axios.get(`/api/Bank/GetSingleItem?id=${bankId}`, {
    headers: {
        Authorization: "Bearer " + localStorage.getItem("serviceToken"),
    },
    params: { Id: bankId },
  });
  //console.log(response);
  return response.data;
};